import { Injectable } from '@angular/core';
import { RouteDataProvider } from '../Shared/RouteDataProvider.provider';
import { AreaDataProvider } from '../Providers/AreaDataProvider';
import { EventType, EventData } from '../Models/sharedModel';
import { UserProvider } from '../Providers/UserProvider';
import { DashboardProvider } from '../Providers/DashboardProvider';
import { WeekEntriesProvider } from '../Providers/WeekEntriesProvider';

@Injectable()

export class UserDataProvider extends AreaDataProvider {

    constructor(public routerDataProvider: RouteDataProvider,
        public userProviders: UserProvider,
        public dashBoardProviders: DashboardProvider,
        public weekEntriesProviders: WeekEntriesProvider) {
        super('Entries', routerDataProvider)
    }

    areaChanged(newArea: string, firstCall: boolean) {
        if (firstCall) {
            return;
        }
    }

    subAreaChanged(newSubArea: string, firstCall: boolean) {
        if (firstCall || newSubArea == this.currentAreaName) {
            return;
        }
        this.eventHandler({ type: EventType.subAreaChanged });
    }

    insideSubAreaChanged(newSubArea: string, firstCall: boolean) {
      if (firstCall || newSubArea == this.currentInsideSubAreaName) {
          return;
      }
      this.eventHandler({ type: EventType.insideSubAreadChanged });
  }

    queryParamChanged(newQueryParams: any, firstCall: boolean) {
        if (firstCall) {
            return;
        }
        if (newQueryParams.id !== undefined) {
            this.eventHandler({ type: EventType.queryParamChanged });
        } else {
            this.eventHandler({ type: EventType.areaChanged });
        }
    }

    urlMaker(data: any): string {
        return "";
    }

    eventHandler(eventData: EventData) {
        this.weekEntriesProviders.getRatingParameter();
        this.dashBoardProviders.getDocuments();
        this.dashBoardProviders.getCampaignData();
        this.dashBoardProviders.getFaQs();
        switch (eventData.type) {
            case EventType.queryParamChanged:
                console.log('Query Param Changed', this.currentQueryParam);
                switch (this.currentQueryParam.id) {
                  case "confirmed":
                    console.log('I am confirmed');
                    this.weekEntriesProviders.getGradesData();
                    this.weekEntriesProviders.getWeekEntries();
                    break;
                }
                break;
            case EventType.areaChanged:
                console.log('Query Param Changed', this.currentAreaName);
            case EventType.subAreaChanged:
                console.log('Sub Area Changed', this.currentSubAreaName);
                switch (this.currentSubAreaName) {
                    case "dashboard":
                        console.log('I am inside Dashboard');
                        this.weekEntriesProviders.getDashboardData();
                        // this.weekEntriesProviders.getWeekEntries();
                        this.weekEntriesProviders.getGrades();
                        this.dashBoardProviders.getCampaignRewards();
                        this.dashBoardProviders.getRewardsBasedData();
                        // this.dashBoardProviders.getRewardTabContent();
                        this.dashBoardProviders.getEntiresBasedTask();
                        this.dashBoardProviders.getDashBoardCounts();
                        break;

                    case "entries-data":
                        console.log("i am inside entries");
                        this.weekEntriesProviders.getGrades();
                        // this.weekEntriesProviders.getWeekEntries();
                        this.weekEntriesProviders.getEntriesCategory();
                        this.weekEntriesProviders.getWinnersEntries();
                        this.weekEntriesProviders.getEntiesWeeks();
                        this.weekEntriesProviders.getEntiesCity();
                        this.weekEntriesProviders.getEntiesPosition();
                        this.dashBoardProviders.getCampaignRewards();
                        this.dashBoardProviders.getDashBoardCounts();
                        this.weekEntriesProviders.getRatingOfEntries();
                        this.weekEntriesProviders.getRatingParameter();
                        this.dashBoardProviders.getEntiresBasedTask();
                        console.log(this.weekEntriesProviders);
                        break;
                    case "winers-list":
                      this.weekEntriesProviders.getGrades();
                      // this.weekEntriesProviders.getWeekEntries();
                      this.weekEntriesProviders.getGradesData();
                      this.weekEntriesProviders.getWinnerList();
                      break;
            }
        }
    }

}
